<template>
  <div class="items-center bg-gray-100 dark:bg-gray-800 rounded-lg p-1 hidden sm:flex">
    <button
      :class="[
        'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
        viewMode === 'list' 
          ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' 
          : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
      ]"
      @click="$emit('update:viewMode', 'list')"
    >
      <ListBulletIcon class="h-4 w-4" />
    </button>
    <button
      :class="[
        'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
        viewMode === 'card' 
          ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' 
          : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
      ]"
      @click="$emit('update:viewMode', 'card')"
    >
      <Squares2X2Icon class="h-4 w-4" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ListBulletIcon, Squares2X2Icon } from '@heroicons/vue/24/outline';

defineProps<{
  viewMode: 'list' | 'card';
}>();

defineEmits<{
  'update:viewMode': [value: 'list' | 'card'];
}>();
</script>
